import React from "react";
import Modal from "react-modal";

type CustomModalProps = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  children?: React.ReactNode;
  height?: string;
  onClose?: () => void;
  parent?: boolean;
};

const CustomModal: React.FC<CustomModalProps> = ({
  modalVisible,
  setModalVisible,
  children,
  height,
  onClose,
  parent,
}) => {
  const isMobile = window.innerWidth < 768;

  const handleClose = () => {
    if (!parent) {
      setModalVisible(false);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={modalVisible}
      onRequestClose={() => handleClose()}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)", // black background with 50% opacity
          zIndex: 999, // z-index of 999
        },
        content: {
          zIndex: 999, // z-index of 999
          borderRadius: "20px", // border radius of 20px
          padding: "20px", // 20px padding on the height of the modal
          top: "50%", // center the modal vertically
          left: "50%", // center the modal horizontally
          transform: "translate(-50%, -50%)", // center the modal both horizontally and vertically
          width: "80vw", // width of 90vw of the viewport width
          maxWidth: isMobile ? "90vw" : "500px", // maximum width of 90vw of the viewport width
          maxHeight: "80vh", // maximum height of 80vh of the viewport height
          height: height || "200px",
          display: "flex", // center the content vertically
          alignItems: "center", // center the content horizontally
          overflow: "hidden",
        },
      }}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
